import * as FPT from './fpt'

/**
 * Loads bodymovin and hearts animation json
 */
export function loadBodyMovin() {
	return Promise.all([
		import(/* webpackChunkName: 'bodymovin' */ 'bodymovin'),
		import(/* webpackChunkName: 'hearts' */ '../vendor/hearts.json'),
	])
	.catch((error) => {
		FPT.trackError({
			message: 'LAZY_LOAD_FAILED',
			code: 'bodymovin',
			error
		});
	})
}

/**
 * Load Progressive Onboarding component (Full Bundle)
 */
export function loadProgressiveOnboarding() {
	return Promise.all([
		import(/* webpackChunkName: 'ProgressiveonboardingFull' */ 'portableonboarding/build/fullBundle')
	]).catch((error) => {
		FPT.trackError({
			message: 'LAZY_LOAD_FAILED',
			code: 'progressive_full',
			error
		});
	})
}

/**
 * Load Progressive Onboarding component (Slick Version)
 */
export function loadSlickProgressiveOnboarding() {
	return Promise.all([
		import(/* webpackChunkName: 'ProgressiveonboardingSlick' */ 'portableonboarding')
	]).catch((error) => {
		FPT.trackError({
			message: 'LAZY_LOAD_FAILED',
			code: 'progressive_slick',
			error
		});
	})
}



// WEBPACK FOOTER //
// ./utility/lazyLoader.js